"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineChartDescriptor = void 0;
var tslib_1 = require("tslib");
var PluggableLineChart_1 = require("./PluggableLineChart");
var BaseChartDescriptor_1 = require("../baseChart/BaseChartDescriptor");
var drillDownUtil_1 = require("../drillDownUtil");
var LineChartDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(LineChartDescriptor, _super);
    function LineChartDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineChartDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableLineChart_1.PluggableLineChart(params); };
    };
    LineChartDescriptor.prototype.applyDrillDown = function (source, drillDownContext) {
        var withFilters = this.addFilters(source, drillDownContext.drillDefinition, drillDownContext.event);
        return drillDownUtil_1.modifyBucketsAttributesForDrillDown(withFilters, drillDownContext.drillDefinition);
    };
    LineChartDescriptor.prototype.addFilters = function (source, drillConfig, event) {
        var cutIntersection = drillDownUtil_1.reverseAndTrimIntersection(drillConfig, event.drillContext.intersection);
        return drillDownUtil_1.addIntersectionFiltersToInsight(source, cutIntersection);
    };
    return LineChartDescriptor;
}(BaseChartDescriptor_1.BaseChartDescriptor));
exports.LineChartDescriptor = LineChartDescriptor;
//# sourceMappingURL=LineChartDescriptor.js.map